// @flow
export const FORMAT_DATE_API = 'yyyy-MM-dd';
